import { useRouter } from 'next/router'
import React, {
  useEffect,
  useState
} from 'react'
import { ItemPanelImage } from '@/layouts/core/types/core'
import NextImage from 'next/image'
import { createLogger } from '@/common/logger'

const logger = createLogger({ prefix: 'ChronoImage' })

// adapted from https://stackoverflow.com/questions/11442712/get-width-height-of-remote-image-from-url
const getImageDims = async(url) => {
  const img = new Image()
  img.src = url
  await img.decode()
  const {
    height,
    width
  } = img
  return {
    height,
    width
  } as Dims
}

type Dims = {
  height: number
  width: number
}

const ChronoImage = (image: ItemPanelImage) => {
  const
    router = useRouter(),
    [dims, setDims] = useState<Dims>(),
    followLink = (e) => {
      e.preventDefault()
      // noinspection JSIgnoredPromiseFromCall
      router.push(image.link)
      return false
    },
    renderImage = () => {
      if (!dims) {
        return null
      }
      return (
        <NextImage
          height={dims.height}
          width={dims.width}
          alt={image.title}
          src={image.src} />
      )
    }

  useEffect(() => {
    logger.debug('Preparing to fetch dims for image: ', image)
    if (!image.src) return
    getImageDims(image.src).then(dims => {
      const maxWidth = image.maxWidth ?? 100
      const scale = dims.width / maxWidth
      const height = dims.width / scale

      const scaledDims = {
        width: maxWidth,
        height
      }
      logger.debug(`Image meta for ${image.src}:`, JSON.stringify({ dims, scaledDims }))
      setDims(scaledDims)
    })
  }, [image])

  useEffect(() => {
    logger.debug('Rendering image: ', image)
  }, [image])

  return (
    <>
      {image.link &&
          <a href={'#'} onClick={followLink}>{renderImage()}</a>
      }
      {!image.link &&
        renderImage()
      }
    </>
  )
}

export default ChronoImage
